import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import jQuery from 'jquery';
import { NoData, ShowMore } from 'rp-react-table';
import classNames from 'classnames';
import EntriesRow from './EntriesRow';

const itemsPerPage = 20;

class EntriesList extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { shownItems: itemsPerPage };
    }

    componentDidMount() {
        this.updatePrices();
    }

    componentWillReceiveProps({ entries }) {
        if (entries !== this.props.entries) {
            this.setState({ shownItems: itemsPerPage });
        }
    }

    componentDidUpdate() {
        this.updatePrices();
    }

    updatePrices = () => {
        jQuery(document).trigger('dynamicPricesUpdated.PRICES');
    }

    showMore = () => {
        this.setState(state => ({ shownItems: state.shownItems + itemsPerPage }));
    }

    render() {
        const { shownItems } = this.state;
        const {
            entries,
            isDamShown,
            isHorseShown,
            noDataText,
            horseName,
            isPriceShown,
        } = this.props;

        return (
            <section className="pp-entries">
                <h2 className="pp-entries__header">
                    Date / {isHorseShown && 'Horse / '}{isDamShown && 'Dam / '}Race
                </h2>
                {entries.length ? (
                    <ul className={classNames({ 'js-diffusionTopicSettingsRace': isPriceShown })} >
                        {entries.slice(0, shownItems).map(row =>
                            <EntriesRow
                                data={{ horseName, ...row }}
                                key={`${row.horseUid}${row.raceInstanceUid}`}
                                isDamShown={isDamShown}
                                isHorseShown={isHorseShown}
                                isPriceShown={isPriceShown}
                            />
                        )}
                    </ul>
                ) : (
                    <NoData text={noDataText} />
                )}
                {shownItems < entries.length && <ShowMore onClick={this.showMore} />}
            </section>
        );
    }
}

EntriesList.propTypes = {
    isHorseShown: PropTypes.bool,
    isPriceShown: PropTypes.bool,
    isDamShown: PropTypes.bool,
    noDataText: PropTypes.string.isRequired,
    horseName: PropTypes.string,
    entries: PropTypes.arrayOf(PropTypes.shape({
        courseStyleName: PropTypes.string,
        courseUid: PropTypes.number,
        horseName: PropTypes.string,
        horseUid: PropTypes.number,
        raceDatetime: PropTypes.string,
        raceInstanceTitle: PropTypes.string,
        raceInstanceUid: PropTypes.number,
        raceStatusCode: PropTypes.string,
        raceUid: PropTypes.number,
    })),
};

export default EntriesList;



// WEBPACK FOOTER //
// ./src/js/shared/entries/EntriesList.jsx